// HomePage.js
import React, { useEffect, useRef } from "react";
import HeroSection from "../components/HeroSection";
import ProductsGrid from "../components/ProductsGrid";
import AboutUs from "../components/AboutUs";
import BlogSection from "../components/BlogSection";
import Newsletter from "../components/Newsletter";
import EcoQualityFeatures from "../components/EcoQualityFeatures";
// import FeaturesSection from "../components/FeaturesSection";
// import Testimonials from "../components/Testimonials";

const HomePage = () => {
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
          entry.target.classList.remove('opacity-0', 'translate-y-8');
        }
      });
    }, observerOptions);

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  return (
    <div className="relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-green-100 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-emerald-100 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-teal-100 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-4000"></div>
      </div>

      {/* Hero Section with enhanced animations */}
      <section 
        ref={addToRefs}
        className="relative opacity-0 translate-y-8 transition-all duration-1000 ease-out"
      >
        <HeroSection />
      </section>

      {/* Eco Quality Features with staggered animation */}
      <section 
        ref={addToRefs}
        className="relative opacity-0 translate-y-8 transition-all duration-1000 ease-out"
        style={{ transitionDelay: '200ms' }}
      >
        <EcoQualityFeatures />
      </section>

      {/* Products Grid with enhanced entrance */}
      <section 
        ref={addToRefs}
        className="relative opacity-0 translate-y-8 transition-all duration-1000 ease-out"
        style={{ transitionDelay: '400ms' }}
      >
        <div className="relative">
          <ProductsGrid />
        </div>
      </section>

      {/* About Us with parallax effect */}
      <section 
        ref={addToRefs}
        className="relative opacity-0 translate-y-8 transition-all duration-1000 ease-out"
        style={{ transitionDelay: '600ms' }}
      >
        <div className="relative overflow-hidden">
          <AboutUs />
        </div>
      </section>

      {/* Blog Section with slide-in animation */}
      {/* <section 
        ref={addToRefs}
        className="relative opacity-0 translate-y-8 transition-all duration-1000 ease-out"
        style={{ transitionDelay: '800ms' }}
      >
        <BlogSection />
      </section> */}

      {/* Newsletter with final animation */}
      <section 
        ref={addToRefs}
        className="relative opacity-0 translate-y-8 transition-all duration-1000 ease-out"
        style={{ transitionDelay: '1000ms' }}
      >
        <Newsletter />
      </section>

      {/* Custom CSS for animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }

        .animation-delay-2000 {
          animation-delay: 2s;
        }

        .animation-delay-4000 {
          animation-delay: 4s;
        }

        /* Smooth scrolling */
        html {
          scroll-behavior: smooth;
        }

        /* Custom scrollbar */
        ::-webkit-scrollbar {
          width: 8px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f1f1;
        }

        ::-webkit-scrollbar-thumb {
          background: linear-gradient(to bottom, #10b981, #059669);
          border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(to bottom, #059669, #047857);
        }
      `}</style>
    </div>
  );
};

export default HomePage;